import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CouponEntity } from '../../domain/entities/CouponEntity'

export class CouponModel extends CouponEntity {
  constructor(dataDto: CouponEntity) {
    super()
    mapEntityProperties<CouponEntity>(this, dataDto, {
      map: {
        onDelivery: {
          ...dataDto.onDelivery,
        }
      }
    })
  }
}
